import {Injectable} from '@angular/core';

@Injectable()
export class ShareDataService {
  data: any;
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/services/share-data.service.ts